export default __webpack_public_path__ + "static/media/assist_web-sm@1x.443cb6df.webp";